<div class="asm-tags-container">
  <mat-form-field class="example-chip-list" appearance="fill">
    <mat-label>ASM Tags</mat-label>
    <mat-chip-list #chipList aria-label="ASM Tags Selection">
      <mat-chip *ngFor="let item of items" (removed)="remove(item)"  (click)="tagOnClick(item)">
        {{item}}
        <button matChipRemove (click)="deleteTag(item)">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>
  </mat-form-field>

  <!--<h4>Add new tag</h4>-->
  <div class="asm-add-tags-grid">
    <mat-form-field appearance="fill">
      <mat-label>Tag</mat-label>
      <mat-select required (selectionChange)="tagSelectorOnChange($event)" [value]="newTag">
        <mat-option *ngFor="let tag of tags" [value]="tag.value">
          {{tag.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="example-form-field" appearance="fill">
      <mat-label>Value</mat-label>
      <input matInput type="text" [(ngModel)]="newTagValue">
      <button *ngIf="newTagValue" matSuffix mat-icon-button aria-label="Clear" (click)="newTagValue=''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <button *ngIf="updateAction === false" [disabled]="newTag.length === 0 || newTagValue.length === 0" (click)="addTag()" mat-raised-button color="warn">Add</button>
    <button *ngIf="updateAction" class="asm-tags-update-btn" [disabled]="newTag.length === 0 || newTagValue.length === 0" (click)="updateTag()" mat-raised-button color="warn">Update</button>

    <div class="asm-guide-link">
      <a target="_blank" href="https://www.advancedshippingmanager.com/Advanced-Shipping-Manager-Variables.pdf">Advanced Shipping Manager Variables</a>
    </div>
  </div>

  <div class="bottom-btn-area">
    <button mat-button (click)="close()">Cancel</button>&nbsp;
    <button [disabled]="params.data.asm_tags === items.join(', ')" (click)="save()" mat-raised-button color="primary">Save</button>
  </div>
</div>
